import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { KnownMetric, ProfileStats } from '../../types/profile';

type ProfileSummaryCardProps = {
  stats: ProfileStats;
};

const summaryPriority: Array<{
  key: keyof ProfileStats;
  nounKey: string;
}> = [
  { key: 'mapsSaved', nounKey: 'mapsSaved' },
  { key: 'routesGenerated', nounKey: 'routesGenerated' },
  { key: 'layersCreated', nounKey: 'layersCreated' },
  { key: 'activeDays', nounKey: 'activeDays' },
  { key: 'loginCount', nounKey: 'loginCount' },
  { key: 'totalSimulationsRun', nounKey: 'totalSimulationsRun' },
];

export const ProfileSummaryCard: React.FC<ProfileSummaryCardProps> = ({ stats }) => {
  const { t } = useTranslation('profile');
  const knownMetrics = summaryPriority
    .map((item) => ({ ...item, metric: stats[item.key] }))
    .filter((item): item is (typeof item & { metric: KnownMetric }) => item.metric.status === 'known');

  if (knownMetrics.length < 2) {
    return null;
  }

  const first = knownMetrics[0];
  const second = knownMetrics[1];

  return (
    <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'action.hover', mb: 2 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        {t('summary.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('summary.sentence', {
          firstValue: first.metric.value,
          firstNoun: t(`summary.nouns.${first.nounKey}`),
          secondValue: second.metric.value,
          secondNoun: t(`summary.nouns.${second.nounKey}`),
        })}
      </Typography>
    </Box>
  );
};
